import { ehPecaVendida } from './mesmaPeca';

/** Status em que o pedido ja e compra. */
const STATUS_PAGOS = ['Pago', 'Pagamento vinculado a comissão'];

/**
 * Pedido que conta como compra nas planilhas da agencia: pago (a API marca
 * Pago quando o Asaas confirma a cobranca - no parcelado, a partir da
 * primeira parcela) ou pago pela comissao. Pendente e cancelado nao contam:
 * pedido sem pagamento ainda nao e compra. Os outros (pedido antigo sem
 * status, em cancelamento) contam so se a cobranca ja foi paga.
 */
export function pedidoContaComoCompra(pedido) {
  if (!pedido || pedido.status === 'Pedido cancelado' || pedido.status === 'Pendente') return false;
  if (STATUS_PAGOS.indexOf(pedido.status) > -1) return true;

  const cobranca = pedido.cobranca || {};
  return Boolean(cobranca.cobrancaPaga) || Number(cobranca.valorJaPago) > 0;
}

/** Os pedidos de um formando (como a API devolve) que contam como compra. */
export function comprasDoFormando(pedidosDoFormando) {
  return ((pedidosDoFormando && pedidosDoFormando.pedidos) || []).filter(pedidoContaComoCompra);
}

/** O que foi cobrado nas compras de um ou de todos os formandos. */
export function valorDasCompras(pedidosPorFormando) {
  return [].concat(pedidosPorFormando || []).reduce(
    (soma, formando) =>
      soma +
      comprasDoFormando(formando).reduce(
        (doFormando, pedido) => doFormando + (Number(pedido.cobranca && pedido.cobranca.valor) || 0),
        0
      ),
    0
  );
}

/**
 * Quais colunas ficam na planilha (true = fica). A peca vendida avulsa vira
 * item do contrato ja no primeiro pedido, antes de ser paga: coluna so de
 * pecas, sem nenhuma compra paga, nao aparece.
 */
export function colunasComCompra(colunas, totais, itens) {
  return (colunas || []).map((coluna, indice) => {
    const ids = (coluna && coluna.ids) || [];
    const soPecas =
      ids.length > 0 &&
      // eslint-disable-next-line eqeqeq
      ids.every((id) => ehPecaVendida((itens || []).find((item) => item.id == id)));

    return !(soPecas && !totais[indice]);
  });
}



// WEBPACK FOOTER //
// ./src/services/pedidosComprados.js